import React, { useState } from "react";
import { MDBRow } from "mdbreact";
import { Button } from "evergreen-ui";
import { Form, Input, message } from "antd";
import { v4 as uuidv4 } from "uuid";
import FireFetch from "../../../Firebase/FireFetch";
import { saveTalmidsUpdates, UI_STRING_KEY_PATTERN } from "../../../utils/translationSheets";

const { TextArea } = Input;

// Add or edit one English master string. Pass `uiString` to edit.
const UiStringActionLayout = (props) => {
	const { uiString, uiStrings = [] } = props;
	const canSave = uiString ? props.canUpdate !== false : props.canCreate !== false;
	const [showLoading, setShowLoading] = useState(false);

	const handleSave = (values) => {
		if (!canSave) {
			message.error("You do not have permission to change UI strings.");
			return;
		}

		const key = String(values.key || "").trim();
		const english = String(values.english || "").trim();
		const module = String(values.module || "").trim();

		if (uiStrings.some((item) => item.key === key && item.id !== uiString?.id)) {
			message.error("A UI string with this key already exists.");
			return;
		}

		const now = Date.now();
		const id = uiString?.id || uuidv4();
		const englishChanged = !uiString || String(uiString.english || "").trim() !== english;
		const record = {
			id,
			key,
			english,
			module,
			createdAt: uiString?.createdAt || now,
			// Bumping updatedAt when English changes marks existing translations as stale.
			updatedAt: englishChanged ? now : uiString?.updatedAt || now,
		};

		setShowLoading(true);
		saveTalmidsUpdates({ [`uiStrings/${id}`]: record }, ["talmidsdb/uiStrings", "talmidsdb/uiStrings/" + id])
			.then(() => {
				FireFetch.addLog("uiStrings", id, uiString ? "Update" : "Create");
				message.success(uiString ? "UI string updated" : "UI string added");
				props.callback && props.callback();
			})
			.catch((error) => {
				message.error("Unable to save: " + error.message);
			})
			.finally(() => setShowLoading(false));
	};

	return (
		<div className="font-Nunito">
			<MDBRow className="p-3">
				<Form
					layout={"vertical"}
					className="w-100"
					disabled={!canSave}
					onFinish={handleSave}
					initialValues={{
						key: uiString?.key,
						english: uiString?.english,
						module: uiString?.module,
					}}
				>
					<Form.Item
						label="Key"
						name="key"
						extra="Stable identifier used by the app, e.g. login.submitButton"
						rules={[
							{ required: true, message: "Key is required" },
							{ pattern: UI_STRING_KEY_PATTERN, message: "Use letters, numbers, dots, dashes or underscores only" },
						]}
					>
						<Input size={"large"} placeholder="e.g. login.submitButton" />
					</Form.Item>
					<Form.Item
						label="English Text"
						name="english"
						rules={[{ required: true, whitespace: true, message: "English text is required" }]}
					>
						<TextArea rows={3} placeholder="e.g. Sign in" />
					</Form.Item>
					<Form.Item label="Module" name="module">
						<Input size={"large"} placeholder="optional, e.g. Login" />
					</Form.Item>
					<Button isLoading={showLoading} appearance="primary" className="mt-1" disabled={!canSave}>
						{uiString ? "Save" : "Add"}
					</Button>
				</Form>
			</MDBRow>
		</div>
	);
};

export default UiStringActionLayout;
